import { render, staticRenderFns } from "./protectRights.vue?vue&type=template&id=4637687d"
import script from "./protectRights.vue?vue&type=script&lang=js"
export * from "./protectRights.vue?vue&type=script&lang=js"
import style0 from "./protectRights.vue?vue&type=style&index=0&id=4637687d&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports